export enum localStorageType {
  INFORMED_USER = "informed-user",
  INFORMED_USER_VALUE = "true"
}